import React from 'react'

import { useWIDGET_CONFIGS } from './_configs'
import { useCloseModal } from '../../../../components/modals/ModalsContext'
import { useOpenEditWebhookStaysModal } from '../../../../utils/routes/modals/modalsActions'
import BigCardPicker from '../../../../packages/kiti/components/form/BigCardPicker'
import { SETTINGS } from '../../../integrations/_services/services'

const WidgetsList = props => {
  const WIDGET_CONFIGS = useWIDGET_CONFIGS()
  const closeModal = useCloseModal()
  const openEditWebhookStaysModal = useOpenEditWebhookStaysModal()

  const handleSelect = ({ id, service, onClick }) => {
    const configuration = SETTINGS[id]

    switch (id) {
      case 'STAYS':
        openEditWebhookStaysModal({ service: service?.toUpperCase() })
        break

      default:
        onClick(configuration)
        closeModal()
        break
    }
  }

  return <BigCardPicker onChange={handleSelect} options={WIDGET_CONFIGS} />
}

export default WidgetsList
